import { render, staticRenderFns } from "./or_dxfm_report.vue?vue&type=template&id=7f923227&scoped=true"
import script from "./or_dxfm_report.vue?vue&type=script&lang=js"
export * from "./or_dxfm_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f923227",
  null
  
)

export default component.exports